import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=4a2cf2c7"
import script from "./goodDetail.vue?vue&type=script&lang=js"
export * from "./goodDetail.vue?vue&type=script&lang=js"
import style0 from "../assets/css/goodDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports